import { useState } from 'react';

const SIZES = { xs: 'w-6 h-6 text-[10px]', sm: 'w-8 h-8 text-xs', md: 'w-10 h-10 text-sm', lg: 'w-12 h-12 text-base' };

// Google profile photo when we have one, otherwise the A&W-orange initial badge.
export default function UserAvatar({ name, picture, size = 'sm', className = '', testId }) {
  const [broken, setBroken] = useState(false);
  const initial = name?.trim()?.charAt(0)?.toUpperCase() || 'U';
  const base = `${SIZES[size] || SIZES.sm} rounded-full shrink-0 flex items-center justify-center overflow-hidden ${className}`;

  if (picture && !broken) {
    return (
      <img
        src={picture}
        alt={name || 'User'}
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        className={`${base} object-cover ring-2 ring-white shadow-sm`}
        data-testid={testId}
      />
    );
  }
  return (
    <div className={`${base} bg-gradient-to-br from-orange-400 to-amber-500 text-white font-bold shadow-sm`} data-testid={testId}>
      {initial}
    </div>
  );
}
